import React from 'react';
import styled from 'styled-components';

const BubbleContainer = styled.div`
  padding: 1em;
  border-radius: 10px;
  margin: 0 0 .5em 0;
  background-color: ${props => props.isRep ? '#3479FF' : '#F23D60'}
`

const Header = styled.h1`
  color: white;
  font-size: 1.4em;
  font-weight: bold;
  margin: 0 0 .4em 0;
`

const Paragraph = styled.h1`
  color: white;
  font-size: 1.2em;
`

class EventBubble extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let {
      isRep,
      content,
    } = this.props.event;

    return (
      <BubbleContainer isRep={isRep}>
        <Header>
          { isRep ? "Rep:" : "Customer:" }
        </Header>
        <Paragraph>
          { content }
        </Paragraph>
      </BubbleContainer>
    )
  }
}

export default EventBubble;